export default __webpack_public_path__ + "static/media/twitter.4e4a24ec.gif";